import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { BoxProps } from '@mui/material/Box';
import RootPage from '../RootPage/RootPage';
import { DEFAULT_PAGE_TITLE } from '@/core/utils/app.constants';

export interface RootErrorPageShape {
  title: string;
  description: string;
  pageTitle?: string;
  cta?: React.ReactNode;
  mainDivProps?: BoxProps;
}

function RootErrorPage({ title, description, pageTitle, cta, mainDivProps }: RootErrorPageShape) {
  useEffect(() => {
    if (pageTitle) {
      document.title = pageTitle;
    }
    return () => {
      document.title = DEFAULT_PAGE_TITLE;
    };
  }, [pageTitle]);

  return (
    <RootPage component="main" {...mainDivProps}>
      <Typography variant="h2" component="h1" textAlign="center">
        {title}
      </Typography>
      <Typography variant="body1" role="alert">
        {description}
      </Typography>
      {cta ? cta : null}
    </RootPage>
  );
}

export default RootErrorPage;
